module.exports = __webpack_public_path__ + "static/media/our-brand-mobile.112bde30.jpg";